import React from "react";

function Contact() {
  return (
    <div className="contact-us" id="contact">
      <div className="c-title  orbitron-font-set">Contact us</div>
      <div className="contact-table">
        <div>
          <b>E-mail: </b>vaicon2025@gmail.com
        </div>
        <div>
          <b>Website: </b> www.vaicon2025.com
        </div>
        <div>
          <b>Mobile No:</b> +91 82838 17442 (Ms. Shivangi)
        </div>
      </div>
    </div>
  );
}

export default Contact;
